import React from 'react';
import {connect} from 'react-redux';

class NoAccess extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    return (
      <div style={{display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center"}}>
        <span style={{fontSize: 170, fontWeight: "bolder", transform: "rotate(90deg)", backgroundColor: "#ccc", borderRadius: 127, width: 250, height: 250, display: "flex", justifyContent: "center", alignItems: "center", paddingBottom: 50}}>:|</span>
        <h1>Parece que você não tem acesso a essa página!</h1>
        <h5>Se você precisar de acesso, contacte um administrador.</h5>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
}

export default connect(mapStateToProps, {})(NoAccess);



// WEBPACK FOOTER //
// ./src/views/NoAccess.js